import { IonFooter, IonRouterLink } from "@ionic/react";
import _ from "lodash";
import React, { Fragment, useEffect, useLayoutEffect, useState } from "react";
import { CONSTANTS } from "../../../constants/callcentral.constants";
import {
  basicFooterMenuConstants,
  footerMenuConstants,
} from "../../../constants/MenuObjects";
import { rolePermissionsService } from "../../../services/rolePermissions.service";
import { menuService } from "../Menu/Menu.service";
import "./FooterMenu.scss";
import { useHistory } from "react-router-dom";
import { dataTransferService } from "../../../services/dataTransferService";
import { useTranslation } from "react-i18next";

const FooterMenu: React.FC = () => {
  const { t } = useTranslation(["menu"]);
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  var [footerMenuList, setFooterMenuList]: any = useState([]);
  var [phaseStatusDetails, setPhaseStatusDetails]: any = useState([]);
  var [isOverFlow, setIsOverFlow]: any = useState(false);
  var [isFooterMenuClicked, setFooterMenuClick]: any = useState(false);
  var [updatedMenuData, setUpdatedMenuData]: any = useState();
  var [MenuList, setMenuList]: any = useState([]);

  let history = useHistory();

  useEffect(() => {
    getPhaseStatusDetails();
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  }, []);

  useEffect(() => {
    if (footerMenuList) {
      setOrderForItems(footerMenuList);
      if (!isFooterMenuClicked) {
        setHomeMenuActive();
      }
      setActiveColor();
    }
  }, [footerMenuList]);

  useEffect(() => {
    if (MenuList) {
      setFooterActiveColor();
    }
  }, [MenuList]);

  useEffect(() => {
    if (phaseStatusDetails) {
      if (footerMenuList) {
        setFooterMenuActive(updatedMenuData);
      }
    }
  }, [phaseStatusDetails]);

  const setHomeMenuActive = () => {
    footerMenuList.map((listItem: any) => {
      if (listItem.menuCode === "HOME") {
        listItem.isMenuSelected = true;
      } else {
        listItem.isMenuSelected = false;
      }
    });
  };

  useEffect(() => {
    if (rolePermissions && !_.isEmpty(rolePermissions)) {
      setFooterMenuListDetails();
    }
  }, [phaseStatusDetails]);

  useLayoutEffect(() => {
    let sub = dataTransferService.getUpdateBtnClickAction.subscribe(
      (data: any) => {
        if (data === true) {
          getPhaseStatusDetails();
          const rolePermissionData =
            rolePermissionsService.getRolePermissionsDetails();
          setRolePermissions(rolePermissionData);
          history.push({
            pathname: "/client/home",
          });
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useLayoutEffect(() => {
    let sub = dataTransferService.getBtnClickAction.subscribe((data: any) => {
      if (data) {
        getPhaseStatusDetails();
        setUpdatedMenuData(data);
      }
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const setFooterMenuListDetails = () => {
    var initialMenuList = setPhaseStatusBasedInitialMenu();
    if (!rolePermissions.myPatients) {
      _.remove(initialMenuList, {
        menuId: CONSTANTS.FOOTER_MENU_LIST_ITEMS.MY_PATIENTS,
      });
    }
    setFooterMenuList(initialMenuList);
  };

  const setOrderForItems = (list: any) => {
    if (list.length === 3) {
      const callScheduleItem = document.getElementById("footer-CallSchedule");
      callScheduleItem?.style.setProperty("order", "2");
    }
    // to show arrows for scrolling if over flows
    const view: any = document.getElementById("footer-menu-container");
    if (view) {
      if (view.scrollWidth > view.clientWidth) {
        setIsOverFlow(true);
      }
    }
  };

  const getPhaseStatusDetails = async () => {
    const params = "";
    const respPhaseDetailsResult: any = await menuService.getPhaseDetails(
      params
    );
    if (respPhaseDetailsResult.isSuccess && respPhaseDetailsResult.result) {
      setPhaseStatusDetails(respPhaseDetailsResult.result?.[0]);
    } else {
      console.log("error");
      menuService.handleErrorResponse();
    }
  };

  const setPhaseStatusBasedInitialMenu = () => {
    var initialMenuList: any = [];
    if (!_.isEmpty(phaseStatusDetails)) {
      //Enable and show all phase 3 menuItems
      if (phaseStatusDetails.phase3Status === 1) {
        initialMenuList = footerMenuConstants;
        basicFooterMenuConstants.map((item: any) => {
          item.disabled = false;
          initialMenuList.push(item);
        });
      }
      //hide all phase 3 menuItems
      else if (phaseStatusDetails.phase3Status === 2) {
        initialMenuList = basicFooterMenuConstants;
      }
      //disable and show all phase 3 menuItems
      else if (phaseStatusDetails.phase3Status === 3) {
        initialMenuList = basicFooterMenuConstants;
        footerMenuConstants.map((item: any) => {
          item.disabled = true;
          initialMenuList.push(item);
        });
      }
    }

    // To remove duplicate menu items if ny
    var uniqueInitialMenuList = Array.from(new Set(initialMenuList));
    // To sort based on menu Id
    uniqueInitialMenuList.sort(
      (item1: any, item2: any) => item1.menuId - item2.menuId
    );
    return uniqueInitialMenuList;
  };

  const setHomeMenuDeActive = () => {
    footerMenuList.map((listItem: any) => {
      if (listItem.menuCode === "HOME") {
        listItem.isMenuSelected = false;
      } else {
        listItem.isMenuSelected = true;
      }
    });
  };

  const setMenuActive = (item: any) => {
    setHomeMenuDeActive();
    const initialArray = _.cloneDeep(footerMenuList);
    initialArray.map((listItem: any) => {
      if (item.menuId === listItem.menuId) {
        listItem.isMenuSelected = true;
      } else {
        listItem.isMenuSelected = false;
      }
    });
    setFooterMenuList(initialArray);
  };

  const setFooterMenuActive = (item: any) => {
    setHomeMenuDeActive();
    const initialArray = _.cloneDeep(footerMenuList);
    initialArray.map((listItem: any) => {
      if (item.menuCode === listItem.menuCode) {
        listItem.isMenuSelected = true;
      } else {
        listItem.isMenuSelected = false;
      }
    });
    setMenuList(initialArray);
  };

  const setActiveColor = () => {
    footerMenuList.map((item: any) => {
      const callScheduleItem = document.getElementById(
        `footer-icon-${item.menuCode}`
      );
      const footerName = document.getElementById(
        `footer-name-${item.menuCode}`
      );
      if (item.isMenuSelected) {
        callScheduleItem?.style.setProperty("color", "#098689");
        footerName?.style.setProperty("color", "#098689");
      } else {
        callScheduleItem?.style.setProperty(
          "color",
          "var(--font-color-tertiary)"
        );
        footerName?.style.setProperty("color", "var(--font-color-tertiary)");
      }
    });
  };

  const setFooterActiveColor = () => {
    MenuList.map((item: any) => {
      const callScheduleItem = document.getElementById(
        `footer-icon-${item.menuCode}`
      );
      const footerName = document.getElementById(
        `footer-name-${item.menuCode}`
      );
      if (item.isMenuSelected) {
        callScheduleItem?.style.setProperty("color", "#098689");
        footerName?.style.setProperty("color", "#098689");
      } else {
        callScheduleItem?.style.setProperty(
          "color",
          "var(--font-color-tertiary)"
        );
        footerName?.style.setProperty("color", "var(--font-color-tertiary)");
      }
    });
  };

  const onLeftClick = () => {
    const view: any = document.getElementById("footer-menu-container");
    view.scrollLeft -= 30;
  };

  const onRightClick = () => {
    const view: any = document.getElementById("footer-menu-container");
    view.scrollLeft += 30;
  };

  const getMenuLabel = (item: any) => {
    switch (item.menuCode) {
      case "HOME":
        return t("menu:home");
      case "On Call Lookup":
        return t("menu:onCallLookUp");
      case "Call Schedule":
        return t("menu:callSchedule");
      case "Chat":
        return t("menu:messages");
      case "Site":
        return t("menu:sites");
      case "My Patients":
        return t("menu:myPatients");
      case "Teams":
        return t("menu:teams");
      default:
        return item.menuName;
    }
  };

  return (
    <IonFooter>
      <div className="footer-menu-wrapper">
        {!_.isEmpty(footerMenuList) && (
          <Fragment>
            {isOverFlow && (
              <div className="back-arrow-scroll" onClick={onLeftClick}>
                <div className="icon-left_arrow"></div>
              </div>
            )}
            <div
              className={`footer-menu-container ${
                !isOverFlow ? "footer-menu-full-width" : ""
              }`}
              id="footer-menu-container"
            >
              {footerMenuList.map((item: any) => {
                return (
                  <IonRouterLink
                    // id={`footer-${item.menuCode}`}
                    className={`router-link-div ${
                      item.disabled ? "disabled-menu" : ""
                    }`}
                    routerLink={item.link}
                    onClick={() => {
                      setMenuActive(item);
                      setFooterMenuClick(true);
                    }}
                  >
                    <div className="footer-menu-item-div">
                      <div className="footer-menu-item">
                        <div
                          className="footer-icon"
                          id={`footer-icon-${item.menuCode}`}
                        >
                          <div className={item.menuIcon}></div>
                        </div>
                        <div
                          className="footer-label"
                          id={`footer-name-${item.menuCode}`}
                        >
                          {getMenuLabel(item)}
                        </div>
                      </div>
                    </div>
                  </IonRouterLink>
                );
              })}
            </div>
            {isOverFlow && (
              <div className="back-arrow-scroll" onClick={onRightClick}>
                <div className="icon-right_arrow"></div>
              </div>
            )}
          </Fragment>
        )}
      </div>
    </IonFooter>
  );
};

export default FooterMenu;
